import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import masterService from 'services/MasterService';

export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false
}

export const designListAll = createAsyncThunk('/design/list', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getDesign(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const designSlice = createSlice({
    name: 'design',
    initialState,
    reducers: {

        designList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(designListAll.pending, (state) => {

                state.loading = false
            })
            .addCase(designListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
    },
})

export const {
    designList


} = designSlice.actions

export default designSlice.reducer